function getVideoObject(videoPreviewData, oldVideoData = {}) {
	const newVideo = {
		...oldVideoData,
		...videoPreviewData,
		thumbnails: {
			...oldVideoData.thumbnails,
			...videoPreviewData.thumbnails,
		},
	}
	return newVideo
}

export { getVideoObject }
